import React from "react"
import { Icon } from "semantic-ui-react"
import { ReactComponent as ChargingIcon } from "../../Icons/charging.svg"
import { batteryLevel } from "../../Utils/util"

const BatteryIcon = ({ data, size }) => {
	const iconSize = size ? size : ""

	return (
		<>
			{!data.battery ? (
				<Icon style={{ margin: "0 0.5rem 0 0", height: "100%" }} name="battery two" size={iconSize} color="grey" />
			) : data.battery.status.toLowerCase() === "charging" || (data.battery.levelP > 90 && data.battery.psInput.toLowerCase() !== "none") ? (
				<ChargingIcon style={{ margin: "0 0.5rem 0 0", height: "18px", color: "grey" }} />
			) : (
				<Icon style={{ height: "100%" }} name={batteryLevel(data.battery.levelP)} size={iconSize} color="grey" />
			)}
		</>
	)
}

export default BatteryIcon
